import type { BreakerQuestion } from '@/features/jobs/questions/questions'
import { QuestionAnswerEditorViewModelBase } from '@/features/jobs/questions/QuestionAnswerEditorViewModelBase'

/**
 * Question answer editor for `Breaker` questions, which end the questionnaire
 * and take no answer.
 */
export class BreakerQuestionAnswerEditorViewModel extends QuestionAnswerEditorViewModelBase<BreakerQuestion> {
  /** @inheritDoc */
  readonly type = 'Breaker'
  /** @inheritDoc */
  readonly isAnswered = true
  /** @inheritDoc */
  readonly answer = null

  /** @inheritDoc */
  set(_question: BreakerQuestion): void {
    // No-op - breaker questions don't have any state.
  }

  /** @inheritDoc */
  protected formatTextAnswer(): string {
    return ''
  }
}
